var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrize2 = function SvgPrize2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.915,
    height: 31.593
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prize-2_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505050"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u7EC4 7830"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19250",
    d: "M491.66 508.9v26.307l12.958 5.286 12.958-5.286V508.9Z",
    transform: "translate(-491.659 -508.904)",
    fill: "url(#prize-2_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19251",
    d: "m12.844 28.281-.089-.038-9.9-4.189V3.118h19.98v20.933Zm-9.533-4.53 9.534 4.033 9.532-4.033V3.575H3.311Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19256",
    d: "M9.989 17.424q1.553-1.294 2.475-2.16a10.01 10.01 0 0 0 1.537-1.8 3.358 3.358 0 0 0 .619-1.847 1.971 1.971 0 0 0-.388-1.294 1.465 1.465 0 0 0-1.202-.474 1.507 1.507 0 0 0-1.245.542 2.362 2.362 0 0 0-.453 1.48h-2.2a3.991 3.991 0 0 1 1.157-2.944 3.942 3.942 0 0 1 2.774-1 3.85 3.85 0 0 1 2.831.979 3.472 3.472 0 0 1 .987 2.58 4.664 4.664 0 0 1-.679 2.41 9.538 9.538 0 0 1-1.553 2q-.875.853-2.282 2.045h4.772v1.877h-7.99v-1.683Z",
    fill: "#fff"
  }))));
};
export default SvgPrize2;